module.exports = {
  "/": {
    "name": "home-page",
    "success": {
      "home page loaded": [
        "HOME_PAGE_LOADED"
      ]
    }
  },
  "/reconnect": {
    "name": "reconnect-page",
    "success": {
      "reconnect page loaded": [
        "RECONNECT_PAGE_LOADED"
      ]
    }
  },
  "/accounts": {
    "name": "accounts-page",
    "success": {
      "accounts page loaded": [
        "ACCOUNTS_PAGE_LOADED"
      ]
    }
  },
  "/:portalId": {},
  "/:portalId/contacts": {
    "name": "portal-contacts-page",
    "success": {
      "portal contacts page loaded": [
        "CONTACTS_PAGE_LOADED"
      ]
    }
  },
  "/:portalId/associations": {
    "name": "portal-associations-page",
    "success": {
      "portal associations page loaded": [
        "ASSOCIATIONS_PAGE_LOADED"
      ]
    }
  },
  "/:portalId/comments": {
    "name": "portal-comments-page",
    "success": {
      "portal comments page loaded": [
        "COMMENTS_PAGE_LOADED"
      ]
    }
  },
  "/:portalId/playbooks": {
    "name": "portal-playbooks-page",
    "success": {
      "portal laybooks page loaded": [
        "PLAYBOOKS_PAGE_LOADED"
      ]
    }
  },
  "/:portalId/outside-active-meeting/draft/:callObjectId/contacts": {
    "name": "outside-meeting-contacts-page",
    "success": {
      "outside meeting contacts page loaded": [
        "CONTACTS_PAGE_LOADED"
      ]
    }
  },
  "/:portalId/outside-active-meeting/draft/:callObjectId/associations": {
    "name": "outside-meeting-associations-page",
    "success": {
      "outside meeting associations page loaded": [
        "ASSOCIATIONS_PAGE_LOADED"
      ]
    }
  },
  "/:portalId/outside-active-meeting/draft/:callObjectId/comments": {
    "name": "outside-meeting-comments-page",
    "success": {
      "outside meeting notes page loaded": [
        "COMMENTS_PAGE_LOADED"
      ]
    }
  },
  "/:portalId/outside-active-meeting/draft/:callObjectId/playbooks": {
    "name": "outside-meeting-playbooks-page",
    "success": {
      "outside meeting playbooks page loaded": [
        "PLAYBOOKS_PAGE_LOADED"
      ]
    }
  }
};